import Vue from "vue";
import Vuex from "vuex"; //引入 vuex
import createPersistedState from "vuex-persistedstate";
import { BIZ_TOKEN, BIZ_USERINFO, BIZ_CURRENT_CART, BIZ_CART_ITEMS, BIZ_LANG, BIZ_LANGUAGE_MAP, BIZ_CURRENCY } from "@/common/constant";
import { getCurrencyList } from "@/api/currency";
import { load_member } from "@/api/upms/profile";
import { setLocal } from "@/lang/i18n";
import { normalizeBackendLanguage, toFrontendLocale } from "@/util/language";
import { homeMoule } from "@/store/home.module";
import { userMoule } from "@/store/user.module";
import { get_current } from "@/api/order/cart.js"
// IM 即时通讯 Vuex 模块（来自 imchat，非命名空间，与 home/user 命名不冲突）
import imChatStore from "@/imchat/store/chatStore.js";
import imFriendStore from "@/imchat/store/friendStore.js";
import imUserStore from "@/imchat/store/userStore.js";
import imGroupStore from "@/imchat/store/groupStore.js";
import imConfigStore from "@/imchat/store/configStore.js";
import imUiStore from "@/imchat/store/uiStore.js";
// import { rechargeMoule } from "@/store/recharge.module";
// import { withdrawMoule } from "@/store/withdraw.module";
// import { productDetailsMoule } from "@/store/productDetails.module";
// import { cartMoule } from "@/store/cart.module";
// import { orderMoule } from "@/store/order.module";
import { showI18nMessage } from '@/common'
import { clearShopAuthStorage } from '@/util/shopAuth'

Vue.use(Vuex); //使用 vuex

const getDefaultLang = () => localStorage.getItem(BIZ_LANG) || BIZ_LANGUAGE_MAP.en
const defaultLang = getDefaultLang()

export default new Vuex.Store({
  modules: {
    home: homeMoule,
    user: userMoule,
    // recharge: rechargeMoule,
    // withdraw: withdrawMoule,
    // productDetails: productDetailsMoule,
    // cart: cartMoule,
    // order: orderMoule,
    // IM 即时通讯模块（模块名与 imchat 内部 this.$store.state.xxx 引用一致）
    chatStore: imChatStore,
    friendStore: imFriendStore,
    userStore: imUserStore,
    groupStore: imGroupStore,
    configStore: imConfigStore,
    uiStore: imUiStore,
  },
  state: {
    token: localStorage.getItem(BIZ_TOKEN) || sessionStorage.getItem(BIZ_TOKEN) || null,
    lang: defaultLang,
    currency: localStorage.getItem(BIZ_CURRENCY) || '',
    currencyList: [],
    baseCurrency: '',
    userInfo: (() => {
      try {
        const raw = sessionStorage.getItem(BIZ_USERINFO) || localStorage.getItem(BIZ_USERINFO);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    })(),
    currentCart: sessionStorage.getItem(BIZ_CURRENT_CART) ? JSON.parse(sessionStorage.getItem(BIZ_CURRENT_CART)) : null,
    cartItems: sessionStorage.getItem(BIZ_CART_ITEMS) ? JSON.parse(sessionStorage.getItem(BIZ_CART_ITEMS)) : null,
    historyData: [],
    searchValue: '',
    headers: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Access-Control-Max-Age': 86400,
      'messages': null,
    },
    headersJson: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'Content-Type': 'application/json',
      'messages': null,
    },
    headersFile: {
      'Authorization': '',
      'username': '',
      'UserId': '',
      'messages': null,
    },
  },
  // plugins: [
  //   createPersistedState({
  //     paths: ["userInfo", "cart"],
  //     storage: window.localStorage
  //   }),
  // ],
  mutations: {
    SETLANG(state, lang) {
      state.lang = lang;
      localStorage.setItem(BIZ_LANG, lang);
    },
    SETCURRENCY(state, code) {
      state.currency = code;
      localStorage.setItem(BIZ_CURRENCY, code);
    },
    SETCURRENCYLIST(state, payload) {
      state.currencyList = payload.currencies || [];
      state.baseCurrency = payload.baseCurrency || '';
    },
    SETTOKEN(state, val) {
      state.token = val || null;
      if (val) {
        sessionStorage.setItem(BIZ_TOKEN, val);
        localStorage.setItem(BIZ_TOKEN, val);
      } else {
        sessionStorage.removeItem(BIZ_TOKEN);
        localStorage.removeItem(BIZ_TOKEN);
      }
    },
    SETHANDERS(state, data) {
      state.headers = {
        'Authorization': data.authorization,
        'username': data.username,
        'UserId': data.userId,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Max-Age': 86400,
        'messages': null,
      },
        state.headersJson = {
          'Authorization': data.authorization,
          'username': data.username,
          'UserId': data.userId,
          'Content-Type': 'application/json',
          'messages': null,
        },
        state.headersFile = {
          'Authorization': data.authorization,
          'username': data.username,
          'UserId': data.userId,
          'messages': null,
        }
    },
    SETUSERINFO(state, userInfo) {
      if (!userInfo || !userInfo.id) {
        state.userInfo = null;
        sessionStorage.removeItem(BIZ_USERINFO);
        localStorage.removeItem(BIZ_USERINFO);
        return;
      }
      state.userInfo = { ...userInfo };
      sessionStorage.setItem(BIZ_USERINFO, JSON.stringify(userInfo));
      localStorage.setItem(BIZ_USERINFO, JSON.stringify(userInfo));
    },
    SETHISTORYDATA(state, data) {
      state.historyData = data
    },
    SETISLOGIN(state, data) {
      state.isLogin = data
    },
    SETCURRENTCART(state, data) {
      state.currentCart = { ...data };
      sessionStorage.setItem(BIZ_CURRENT_CART, JSON.stringify(data));
    },
    SETCARTQUANTITY(state, data) {
      state.cartQuantity = data
    },
    SETCARTITEMS(state, data) {
      state.cartItems = data;
      sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(data));
    },
    UPDATECARTITEMS(state,data) {
      // 更新数量
      if (state.cartItems && state.cartItems.length>0) {
        if (-1<data.index && data.quantity) {
          state.cartItems[data.index].quantity = data.quantity;
          state.cartItems[data.index].subtotal = data.quantity*state.cartItems[data.index].price;
         
        }
        if (-1<data.index && data.checked) {
          state.cartItems[data.index].checked = data.checked;
        }
        sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(state.cartItems));
      }
    },
    REMOVECARTITEMS(state,itemIndex) {
      // 更新数量
      if (-1<itemIndex && state.cartItems && state.cartItems.length) {
        // const newArray = array.filter(obj => obj.id !== idToRemove);
        state.cartItems.splice(itemIndex, 1);
        sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(state.cartItems));
      }
    },
    CLEARCART(state) {
      state.cartItems = [];
      state.currentCart = {};
      sessionStorage.removeItem(BIZ_CURRENT_CART);
      sessionStorage.removeItem(BIZ_CART_ITEMS);
    },
    LOADCARTITEMS(state) {
      if (state.currentCart && state.currentCart.id) {
        get_current({
          "currentCartId": state.currentCart.id
        }).then(response => {
          if(response.data.data.cartItems){
            state.cartItems = response.data.data.cartItems;
            sessionStorage.setItem(BIZ_CART_ITEMS, JSON.stringify(response.data.data.cartItems));
          }
        });
      }
    },
    UPDATESEARCHVALUE(state, val) {
      state.searchValue = val;
    },


    // commit('SET_ACCESS_TOKEN', data.access_token)
    // commit('SET_REFRESH_TOKEN', data.refresh_token)
  },
  actions: {
    asyncToken(context, val) {
      context.commit("SETTOKEN", val);
    },
    async getUserInfo({ commit }) {
      try {

        const userInfo = await UserInfoApi();

        commit("SETUSERINFO", userInfo.data);
        return Promise.resolve();
      } catch (error) {
        console.log('error ->', error);
        return Promise.reject();
      }
    },
    async loadCurrencies({ commit, state }) {
      try {
        const res = await getCurrencyList();
        // request 默认导出为 axios，resolve 为完整响应；R 包装后取 res.data.data
        const data = (res && res.data && res.data.data) || {};
        const currencies = data.currencies || [];
        const baseCurrency = data.baseCurrency || '';
        commit("SETCURRENCYLIST", { currencies, baseCurrency });
        // 解析当前币种：会员偏好 > localStorage > 基准币
        const valid = (code) => !!code && currencies.some((c) => c.currencyCode === code);
        let memberPref = state.userInfo && state.userInfo.currencyCode;
        // 登录接口仅返回 BizUser（无 currencyCode），已登录时从会员资料拉取 DB 偏好
        if (!memberPref && state.token) {
          try {
            const memberRes = await load_member();
            const code = memberRes?.data?.data?.member?.currencyCode;
            if (code) {
              memberPref = code;
              if (state.userInfo && state.userInfo.id) {
                commit("SETUSERINFO", { ...state.userInfo, currencyCode: code });
              }
            }
          } catch (e) {
            // 忽略，回退 localStorage / 基准币
          }
        }
        const localPref = localStorage.getItem(BIZ_CURRENCY);
        // 关闭多币种时强制使用基准币，忽略会员/本地偏好，避免登录用户残留偏好（如 USD）导致页面出现双币种
        const multiCurrencyEnabled = localStorage.getItem('shop_multiCurrencyEnabled') !== 'false';
        const current = !multiCurrencyEnabled
          ? baseCurrency
          : (valid(memberPref) ? memberPref : valid(localPref) ? localPref : baseCurrency);
        commit("SETCURRENCY", current);
        // #region agent log
        fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix',hypothesisId:'F',location:'store.js:loadCurrencies',message:'currencies loaded',data:{baseCurrency:baseCurrency,count:currencies.length,localPref:localPref,memberPref:memberPref||null,multiCurrencyEnabled:multiCurrencyEnabled,current:current},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
        return Promise.resolve(currencies);
      } catch (error) {
        console.log("loadCurrencies error ->", error);
        return Promise.reject(error);
      }
    },
    async applyMemberLanguagePreference({ state }) {
      if (!state.token) {
        return false;
      }
      // 关闭多语言时已在挂载前强制中文；此处跳过会员语言偏好，避免与强制中文相互 reload 造成死循环
      const multiLanguageEnabled = localStorage.getItem('shop_multiLanguageEnabled') !== 'false';
      if (!multiLanguageEnabled) {
        // #region agent log
        fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix',hypothesisId:'E',location:'store.js:applyMemberLang',message:'skip (multiLanguage disabled)',data:{stateLang:state.lang},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
        return false;
      }
      try {
        const memberRes = await load_member();
        const member = memberRes && memberRes.data && memberRes.data.data && memberRes.data.data.member;
        const frontendLocale = toFrontendLocale(normalizeBackendLanguage(member && member.language));
        // #region agent log
        fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'1b1377'},body:JSON.stringify({sessionId:'1b1377',runId:'post-fix',hypothesisId:'E',location:'store.js:applyMemberLang',message:'enabled path',data:{stateLang:state.lang,frontendLocale:frontendLocale,willReload:!!(frontendLocale && frontendLocale !== state.lang)},timestamp:Date.now()})}).catch(()=>{});
        // #endregion
        if (!frontendLocale || frontendLocale === state.lang) {
          return false;
        }
        await new Promise((resolve) => {
          setLocal(frontendLocale, resolve);
        });
        window.location.reload();
        return true;
      } catch (error) {
        return false;
      }
    },
    async logout({ commit }) {
      // #region agent log
      fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6c2a0d'},body:JSON.stringify({sessionId:'6c2a0d',runId:'pc-logout',hypothesisId:'H1',location:'store.js:logout',message:'logout before clear',data:{localToken:!!localStorage.getItem(BIZ_TOKEN),sessionToken:!!sessionStorage.getItem(BIZ_TOKEN)},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
      commit("CLEARCART", []);
      clearShopAuthStorage({ commit });
      // #region agent log
      fetch('http://127.0.0.1:7740/ingest/a9351a5b-1e14-43d3-b4dd-3beb0ed6fb3c',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'6c2a0d'},body:JSON.stringify({sessionId:'6c2a0d',runId:'pc-logout',hypothesisId:'H1',location:'store.js:logout',message:'logout after clear',data:{localToken:!!localStorage.getItem(BIZ_TOKEN),sessionToken:!!sessionStorage.getItem(BIZ_TOKEN)},timestamp:Date.now()})}).catch(()=>{});
      // #endregion
      showI18nMessage('message.home.operationSuccess')
      return Promise.resolve();
    },
  },
  getters: {
    existToken: (state) => {
      const token = sessionStorage.getItem(BIZ_TOKEN);
      if (token) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 用户缓存
     * userInfoStorage
     * @param {*} state 
     * @returns 
     */
    userInfo: (state) => state.userInfo,

    /**
     * 是否登录
     * @param {*} state 
     * @returns 
     */
    isLogin: (state) => !!state.token,

    /**
     * 当前语言
     * @param {*} state 
     * @returns 
     */
    currentLang: (state) => state.lang,
    /**
     * 启用币种列表（含当前汇率、小数位）
     */
    currencyList: (state) => state.currencyList,
    /**
     * 基准币种代码
     */
    baseCurrency: (state) => state.baseCurrency,
    /**
     * 当前所选币种代码
     */
    currentCurrencyCode: (state) => state.currency,
    /**
     * 当前所选币种对象（含 symbol/rate/decimalPlaces）
     */
    currentCurrency: (state) =>
      state.currencyList.find((c) => c.currencyCode === state.currency) || null,
    /**
     * 搜索历史
     * historyKeywordList
     * @param {*} state 
     * @returns 
     */
    historyData: (state) => state.historyData,
    /**
     * 当前购物车
     * @param {*} state 
     * @returns 
     */
    currentCart: (state) => state.currentCart,
    /**
     * 购物车商品项
     * @param {*} state
     * @returns
     */
    cartItems: (state) => state.cartItems,
    /**
     * 购物车商品总数量（所有 cartItem.quantity 之和），供装修业务组件 CartIcon badge 使用
     * @param {*} state
     * @returns {number}
     */
    cartCount: (state) => {
      if (!state.cartItems || !state.cartItems.length) return 0;
      return state.cartItems.reduce((sum, item) => sum + (parseInt(item.quantity, 10) || 0), 0);
    },
    /**
     * 购物车商品数量
     * @param {*} state
     * @returns
     */
    cartQuantity: (state) => state.cartQuantity,

    /**
     * get请求方法头
     * @param {*} state 
     * @returns 
     */
    headers: (state) => state.headers,

    /**
     * post请求方法头
     * @param {*} state 
     * @returns 
     */
    headersJson: (state) => state.headersJson,

    /**
     * file传递方法头
     * @param {*} state 
     * @returns 
     */
    headersFile: (state) => state.headersFile,

    /**
     * 搜索词
     * @param {*} state 
     * @returns 
     */
    searchValue: (state) => state.searchValue,
  },
});
